import angular from 'angular';

const componentOptions = {
    bindings: {
        model : '=',
        info : '=',
        containerForm: '=',
        importError: '=',
        groupSelected: '<',
        flow: '<',
        contributionCardData: '<'
    },
    controllerAs : 'ibGiftCardsImportCtrl',
    templateUrl: ['GiftCardsAppConstants', (GiftCardsAppConstants: GiftCardsAppConstant): string => `${GiftCardsAppConstants.templatesRoute}ib-gift-cards-import-view.html`]
};
const componentInfo = {
    module: 'ib-gift-cards-configuration-form-module',
    selector: 'ibGiftCardsImport',
    inject:['$timeout', 'localStorageService', 'CurrencyService', 'GiftCardsAppConstants', '$filter', 'CommonsUtilService', 'DigitalDataService', '$rootScope'],
    required: []
};
export class ibGiftCardsImport implements ng.IController {

    private amountEvent : Types.amountEvent;
    private keydown : boolean;
    private onblur : boolean;
    private customPrice: number;
    private dynamicPrice: string;
    private model : Types.FixedPrice;
    private flow: string;
    private groupSelected: string;
    private boolGroupSelected: boolean;
    private info : Types.AvailabilityGiftCards;
    private focused : boolean;
    private dynamicError : boolean;
    private importError: boolean;
    private containerForm: any;
    private PHONE_CLEANER: string;
    private PRICE_INTEGER: RegExp;
    private MAX_LENGTH: number;
    private radioId: string;
    private errorMessage: string;
    private contributionCardData: Types.contributionCardData;
    private that:ibGiftCardsImport;
    constructor (private $timeout: ng.ITimeoutService, private localStorageService: angular.local.storage.ILocalStorageService,
        private CurrencyService: any, private GiftCardsAppConstants: GiftCardsAppConstant,
        private $filter: angular.IFilterService, private CommonsUtilService: any, private DigitalDataService: any, private $rootScope) {

        this.PHONE_CLEANER = this.GiftCardsAppConstants.PATTERNS.PHONE_CLEANER;
        this.PRICE_INTEGER = this.GiftCardsAppConstants.PATTERNS.PRICE_INTEGER;
        this.MAX_LENGTH = String(this.info?.customPrice?.maxAmount).length;
        this.amountEvent = {
            onblur : false,
            dynamicPrice : null,
            keydown : false,
            focused : false,
            customPrice : null,
            dynamicError : false,
            importError : false
        };
        this.$rootScope.$on('changeFixedPriceSelected', this.changeFixedPriceSelected);
        this.$rootScope.$on('setConditions', this.setConditions);
    }

    changeFixedPriceSelected = (event) => {
        this.boolGroupSelected = this.groupSelected === 'true';
        this.$timeout( () => {
            this.model = !this.boolGroupSelected ?  this.info?.fixedPrices[0] : this.info?.groupFixedPrices[0];
        }, 500);
    };

    keydownInput = () => {
        const amountEventTemp = this.CommonsUtilService.keydownInput(this);
        this.amountEvent.onblur = amountEventTemp.onblur;
        this.importError = amountEventTemp.importError;
        this.amountEvent.keydown = amountEventTemp.keydown;
        this.$timeout( () => {
            this.amountEvent.keydown = false;
            this.amountEvent.onblur = this.amountEvent.customPrice !== null;
        }, 2000);
    };

    onChangeAction = () :void =>{
        this.boolGroupSelected = this.groupSelected === 'true';
        let typeCustomDiscount = this.boolGroupSelected || this.flow === 'contribution' ? 'groupCustomPrice' : 'customPrice';
        const maxAmounNotNullOr0OrGreaterDynamicprice = (this.info?.[typeCustomDiscount]?.maxAmount === null || this.info?.[typeCustomDiscount]?.maxAmount === 0 || parseInt(this.amountEvent.dynamicPrice) <= this.info?.[typeCustomDiscount]?.maxAmount),
            minAmounNotNullOr0OrLessDynamicprice = (this.info?.[typeCustomDiscount]?.minAmount === null || this.info?.[typeCustomDiscount]?.minAmount === 0 || parseInt(this.amountEvent.dynamicPrice) >= this.info?.[typeCustomDiscount]?.minAmount),
            minAmountAndMaxAmountNotExist = !this.info?.[typeCustomDiscount]?.minAmount && !this.info?.[typeCustomDiscount]?.maxAmount,
            customPriceExist = (this.info?.[typeCustomDiscount]?.percentage >= 0),
            maxAmountNotNullOrGreater0 = (this.info?.[typeCustomDiscount]?.maxAmount !== null || this.info?.[typeCustomDiscount]?.maxAmount > 0),
            dinamicPriceGreaterMaxAmount = (parseInt(this.amountEvent.dynamicPrice) > this.info?.[typeCustomDiscount]?.maxAmount),
            minAmountNotNullOrGreater0 = (this.info?.[typeCustomDiscount]?.minAmount !== null || this.info?.[typeCustomDiscount]?.minAmount > 0),
            dinamicPriceLessMinAmount = (parseInt(this.amountEvent.dynamicPrice) < this.info?.[typeCustomDiscount]?.minAmount),
            minAmountAndMaxAmountExist = (this.info?.[typeCustomDiscount]?.minAmount && this.info?.[typeCustomDiscount]?.maxAmount),
            minAmountNotExistMaxAmountExist = (!this.info?.[typeCustomDiscount]?.minAmount && this.info?.[typeCustomDiscount]?.maxAmount),
            minAmountExistMaxAmountNotExist = (this.info?.[typeCustomDiscount]?.minAmount && !this.info?.[typeCustomDiscount]?.maxAmount);
        this.amountEvent.keydown = false;
        this.amountEvent.dynamicError = this.amountEvent.dynamicPrice === undefined && this.containerForm.customAmount?.$viewValue &&
        this.containerForm.customAmount?.$viewValue!=='';

        const customPriceRoute = this.boolGroupSelected || this.flow == this.GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION ? 'groupCustomPrice' : 'customPrice';
          
        if( ((maxAmountNotNullOrGreater0 && dinamicPriceGreaterMaxAmount) || (minAmountNotNullOrGreater0 && dinamicPriceLessMinAmount))) {
            if(minAmountAndMaxAmountExist) {
                this.errorMessage = this.$filter('translate')('GIFT_CARD_IMPORT_ERROR_BETWEEN_DYNAMIC_PRICE').replace('XXX', this.info?.[typeCustomDiscount]?.minAmount.toString()).replace('YYYY', this.info?.[typeCustomDiscount]?.maxAmount.toString());
            }else if(minAmountNotExistMaxAmountExist) {
                this.errorMessage = this.$filter('translate')('GIFT_CARD_IMPORT_ERROR_MAX_DYNAMIC_PRICE');
            }else if(minAmountExistMaxAmountNotExist) {
                this.errorMessage = this.$filter('translate')('GIFT_CARD_IMPORT_ERROR_MIN_DYNAMIC_PRICE');
            }
            this.amountEvent.dynamicError =true;
            this.model = null;
            this.amountEvent.customPrice = null;
        } else if(this.amountEvent.dynamicPrice && (maxAmounNotNullOr0OrGreaterDynamicprice || minAmounNotNullOr0OrLessDynamicprice || minAmountAndMaxAmountNotExist) && customPriceExist) {
            this.amountEvent.onblur = true;
            this.amountEvent.customPrice  = parseInt(this.amountEvent.dynamicPrice) - ( parseInt(this.amountEvent.dynamicPrice) * (this.info?.[typeCustomDiscount].percentage / 100));
            
            this.model = {
                amount: parseInt(this.amountEvent.dynamicPrice),
                price:this.CurrencyService.formatPrice(
                    this.info?.currency,
                    parseInt(this.amountEvent.dynamicPrice),
                    false
                ),
                campaignId: this.info[customPriceRoute]?.campaignId,
                name: '',
                discount: {
                    amount: this.amountEvent.customPrice,
                    percentage: this.info?.[typeCustomDiscount].percentage === 0 ? null : this.info?.[typeCustomDiscount].percentage,
                    price: this.CurrencyService.formatPrice(
                        this.info?.currency,
                        this.amountEvent.customPrice,
                        true
                    )
                }
            };
            this.setConditions();
        } else if((this.amountEvent.dynamicPrice === undefined  || this.amountEvent.dynamicPrice === null || this.amountEvent.dynamicPrice ==='')  &&  this.amountEvent.customPrice !== null) {
            this.model = null;
            this.amountEvent.customPrice = null;
            this.amountEvent.dynamicError =false;
        }

    };

    resetFields = () :void=> {
        this.amountEvent = this.CommonsUtilService.resetFields(this.amountEvent);
        this.importError = this.amountEvent.importError;
    };

    setConditions = (event?, radioId?:string) :void =>{
        this.boolGroupSelected = this.groupSelected === 'true';
        let campaingSelected, infoFixedPriceRoute, infoCampaignRoute;
        const conditionInfoTemp: Types.ConditionSuccess = angular.copy(this.info?.conditionInfo);
        
        if(this.boolGroupSelected || this.flow == this.GiftCardsAppConstants.GIFT_CARD_FLOWS.CONTRIBUTION) {
            infoFixedPriceRoute = 'groupFixedPrices';
            infoCampaignRoute = 'groupCampaigns';
        }else {
            infoFixedPriceRoute = 'fixedPrices';
            infoCampaignRoute = 'campaigns';
        }

        
        const checkSelectedConditionText = () => {
            if(radioId) {
                angular.forEach(this.info[infoFixedPriceRoute], ( fixedPrice : Types.FixedPrice) =>{
                    if(fixedPrice.name === radioId) {
                        this.info.conditionInfo.selectedCondition.text = fixedPrice.price;
                        if (this.contributionCardData) {
                            this.info.conditionInfo.selectedCondition.totalContribution = this.CurrencyService.formatPrice (this.info?.currency, fixedPrice.amount + this.contributionCardData.amount, false);
                        }       
                    }
                });
            }else{
                this.info.conditionInfo.selectedCondition.text = this.model.price;
                if (this.contributionCardData) {
                    this.info.conditionInfo.selectedCondition.totalContribution =  this.CurrencyService.formatPrice (this.info?.currency, this.model.discount.amount + this.contributionCardData.amount, false); 
                }
            }
        };
    
        if(radioId) {
            angular.forEach(this.info[infoFixedPriceRoute], ( fixedPrice : Types.FixedPrice) =>{
                if(fixedPrice.name === radioId) {
                    campaingSelected = fixedPrice.campaignId;
                }
            });
        }
        if(campaingSelected) {
            angular.forEach(this.info[infoCampaignRoute], ( condition : Types.CampaignsList) =>{
                if(condition.campaignId === campaingSelected) {
                    this.info.conditionInfo.selectedCondition = condition;
                }
            });
        }else {
            this.info.conditionInfo.selectedCondition = this.info[infoCampaignRoute][this.info[infoCampaignRoute].length -1];
        }
        
        checkSelectedConditionText();
        this.info.conditionInfo.campaigns = conditionInfoTemp?.campaigns;
        this.info.conditionInfo.groupCampaigns = conditionInfoTemp?.groupCampaigns;
        
        this.DigitalDataService.addDigitalDataInfo({GiftCardCampaign: this.info?.conditionInfo?.selectedCondition?.commercialCode ? this.info?.conditionInfo?.selectedCondition?.commercialCode : 'sin campaña'});
        this.$timeout(() => {
            this.$rootScope.$broadcast('sendUpdateToMonetate');
            this.$rootScope.$broadcast('updateDatalayer');            
            this.$rootScope.$broadcast('updateDigitalData');
        });
    };



}
try {
    const mod = angular.module(componentInfo.module);
    ibGiftCardsImport.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsImport })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGiftCardsImport.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGiftCardsImport })
    );
}